export enum SituacaoPreAnalise {
	UNDEFINED = 0,
	EM_PREENCHIMENTO = 1,
	PROPOSTA_NAO_GERADA = 2,
	PROPOSTA_GERADA = 3,
	LINK_ENVIADO = 4,
	LINK_EXPIRADO = 5,
	LINK_FINALIZADO = 6,
	LINK_COPIADO = 7
}

export const SituacaoPreAnaliseLabel = new Map<SituacaoPreAnalise, string>([
    [SituacaoPreAnalise.UNDEFINED, '-'],
    [SituacaoPreAnalise.PROPOSTA_NAO_GERADA, 'Proposta não gerada'],
    [SituacaoPreAnalise.PROPOSTA_GERADA, 'Proposta gerada'],
    [SituacaoPreAnalise.EM_PREENCHIMENTO, 'Em preenchimento'],
    [SituacaoPreAnalise.LINK_COPIADO, 'Link copiado'],
]);
